import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'

import { tradingSeatsContext } from '../../config/seatTrade'
import getLabels from '../../utils/getLabels'

import Button from '../Button'
import ContextMenu from '../ContextMenu'
import Autocomplete from '../AutocompleteSimple'

class SeatTradeMenu extends Component {
  renderAutocomplete = ({ classes, input, options, placeholder }) => {
    return (
      <Autocomplete
        options={options}
        onSelect={input.onChange}
        value={input.value.label}
        inputFieldProps={{
          name: input.name,
          placeholder: getLabels(placeholder),
          browserAutocomplete: 'off',
          inputClassName: classes.inputField,
          value: input.value.label || input.value,
        }}
      />
    )
  }

  componentDidMount() {
    this.props.requestFilteredTourOperators()
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.tourOperatorsOptions &&
        prevProps.tourOperatorsOptions.length) !==
      (this.props.tourOperatorsOptions &&
        this.props.tourOperatorsOptions.length)
    ) {
      this.props.resetTouroperatorField()
    }
  }

  renderSelectTourOperatorContext() {
    const {
      classes,
      tourOperatorsOptions,
      isSeatTradeValid,
      setContextMenu,
      seatsAreBeingTraded,
    } = this.props

    return (
      <React.Fragment>
        <section className={classes.operatorSelect}>
          <h4>{`${getLabels('trade_seats_with')}`}</h4>
          <Field
            name="tourOperator"
            component={this.renderAutocomplete}
            options={tourOperatorsOptions}
            placeholder="tourOperator"
            data-element="seat-trade-tour-operators-select"
            classes={classes}
          />
        </section>
        <Button
          name="tradeSeatsSubmit"
          className={classes.buttonSave}
          isDisabled={!isSeatTradeValid || seatsAreBeingTraded}
          data-element="trade-seats"
          onClick={() => {
            setContextMenu(tradingSeatsContext)
          }}
        >
          {getLabels('trade_seats')}
        </Button>
      </React.Fragment>
    )
  }

  renderTradeSeatsContext() {
    const {
      classes,
      isSeatTradeValid,
      setContextMenu,
      onSeatTrade,
      seatsAreBeingTraded,
    } = this.props

    return (
      <React.Fragment>
        <Button
          name="tradeSeatsCancel"
          className={classes.buttonLeft}
          color="white"
          isDisabled={!isSeatTradeValid || seatsAreBeingTraded}
          data-element="trade-seats-cancel"
          onClick={() => {
            setContextMenu('')
          }}
        >
          {getLabels('no_seat_trade')}
        </Button>

        {/*
          React doesn't see this as a new button,
          but the same button as in the renderSelectTourOperatorContext component.
          Therefor it keeps focus on this button after clicking the other one.
          By wrapping the element in a fragment, this behavior is bypassed.
        */}
        <React.Fragment>
          <Button
            name="tradeSeatsSubmit"
            className={classes.buttonSave}
            isDisabled={!isSeatTradeValid || seatsAreBeingTraded}
            data-element="trade-seats"
            onClick={() => {
              onSeatTrade()
            }}
          >
            {getLabels('yes_trade_seats')}
          </Button>
        </React.Fragment>
      </React.Fragment>
    )
  }

  renderContext() {
    const { context } = this.props

    switch (context) {
      case tradingSeatsContext:
        return this.renderTradeSeatsContext()
      default:
        return this.renderSelectTourOperatorContext()
    }
  }

  render() {
    return <ContextMenu hidden={false}>{this.renderContext()}</ContextMenu>
  }
}

SeatTradeMenu.propTypes = {
  classes: PropTypes.shape({
    buttonDelete: PropTypes.string,
    buttonEdit: PropTypes.string,
  }),
  tourOperators: PropTypes.array,
  resetTouroperatorField: PropTypes.func,
  setContextMenu: PropTypes.func.isRequired,
}

export default SeatTradeMenu
